import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import CursorFollower from './CursorFollower';
import ScrollToTopButton from './ScrollToTopButton';
import ScrollReset from './ScrollReset';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';
import { Toaster } from 'sonner';
import NewsLetter from './pages/NewsLetter/NewsLetter';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ScrollReset />
      <div className="App">
      <Toaster richColors position="top-right" />
        <CursorFollower />
        <Router />
        <ScrollToTopButton />
        <NewsLetter />
      </div>
    </BrowserRouter>
  );
}

export default App;
